export default "__VITE_PUBLIC_ASSET__4022197a__"